// @flow

import React, { Component } from "react";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
// lazily load most pages
import RLLoadable from "react-loadable";
import "./assets/tailwind.css";

// Components
import Layout from "./components/layout";
import Navbar from "./components/navbar";
import ScrollToTop from "./components/scrollToTop";
import PerformanceTools from "./components/performanceTools";

// pages that we dont lazy load for perf reasons
import Homepage from "./pages/software";

// GA
import withTracker from "./components/withTracker";
import TagManager from "react-gtm-module";

// Google tag mananger
const tagManagerArgs = {
  gtmId: "GTM-NHXSFKN",
};
TagManager.initialize(tagManagerArgs);

const LoadingProgress = () => <div></div>;
const Loadable = (args) => {
  const loadable = RLLoadable(args);
  // once the first page has rendered, preload all the other pages
  loadable.preload();
  return loadable;
};

type Props = {};

class App extends Component<Props> {
  render() {
    return (
      <React.Fragment>
        <BrowserRouter>
          <PerformanceTools />
          <ScrollToTop />
          <Navbar />
          <Layout>
            <Switch>
              <Redirect exact from="/us" to="/" />
              <Redirect exact from="/us/about" to="/about" />
              <Route
                exact
                path="/:country(us|uk)?"
                component={withTracker(Homepage)}
              />
              {/* SEO tweak */}
              <Redirect
                exact
                from="/industry/aged-care"
                to="/industry/elderly-care"
              />
              <Redirect
                exact
                from="/company/small-and-medium"
                to="/company/mid-market"
              />
              <Redirect
                exact
                from="/software/gps-clock-ins"
                to="/software/timeclock-app"
              />
                <Redirect
                exact
                from="/employee-scheduling-software/"
                to="/software/scheduling-software"
              />
                <Redirect
                exact
                from="/employee-scheduling-software/r"
                to="/software/scheduling-software"
              />
              <Route
                path="/news/opt-in"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/OptInConfirm.js"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/whitepapers"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/Whitepapers.js"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/subscribe"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/Subscribe.js"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Redirect exact from="/uk/try-uk" to="/uk/try" />
              {/* SEO End Tweak */}
              {/* FINANCE PAGE TEMP */}
              <Redirect exact from="/role/finance" to="/finance" />
              <Route
                exact
                path="/finance"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/Finance.js"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                path="/:country(us|uk)?/try"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/SignupUS.js"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/software/scheduling-software"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/schedulingSoftware"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/software/wage-and-hour-compliance"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/compliance"),
                    loading: LoadingProgress,
                  })
                )}
              />
              {/* redirect for a renamed url page ^ */}
              <Redirect
                exact
                from="/software/labor-compliance"
                to="/software/wage-and-hour-compliance"
              />
              <Route
                exact
                path="/:country(us|uk)?/software/time-and-attendance"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/timeAndAttendance"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/software/workforce-analytics"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/workforceAnalytics"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/software/timeclock-app"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/timeclockApp"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/software/employee-onboarding"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/employeeOnboarding"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/software/live-insights"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/liveInsights"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/software/auto-scheduling"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/autoScheduling"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                path="/:country(us|uk)?/software/:slug"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/features"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Redirect
                exact
                from="/:country(us|uk)?/industry/medical-and-pharmacy"
                to="/industry/pharmacy"
              />
              <Route
                exact
                path="/:country(us|uk)?/industry/hospitals/scheduling"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/hospitals"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/industry/call-center/scheduling"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/call-center-scheduling"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/industry/call-center/workforce-management"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/call-center-management"),
                    loading: LoadingProgress,
                  })
                )}
              />
              {/* <Route
                exact
                path="/:country(us|uk)?/industry/call-center/workforce-management"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/callCenterManagement"),
                    loading: LoadingProgress,
                  })
                )}
              /> */}
              <Route
                exact
                path="/:country(us|uk)?/industry/healthcare"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/healthcare"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/industry/elderly-care"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/elderly-care"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/industry/elderly-care/scheduling"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/elderly-care-scheduling"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/industry/construction/scheduling"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/construction-scheduling.js"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/industry/restaurant-and-bars"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/restaurants"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/uk/industry/restaurant-and-dining"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/restaurants"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                path="/:country(us|uk)?/industry/:slug"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/industries"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                path="/:country(us|uk)?/role/:slug"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/roles"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                path="/:country(us|uk)?/company/:slug"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/companies"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/integrations/:slug"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/integrations"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/integrations"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/marketplace"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/workforce-management"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/management"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/videos/:slug"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/singleVideo"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/tools/timesheet-calculator"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/timesheetCalculator"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/tools/scheduling-template"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/schedulingTemplate"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/news/page/:pageNo?"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/blog"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                strict
                sensitive
                path="/:country(us|uk)?/news"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/blog"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/about"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/about"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/pricing"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/PricingV2"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(uk)?/pricing"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/pricing"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/contact-us"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/contact"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/api"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/api"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|eu)?/privacy-policy"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/privacy"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/security"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/security"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/terms"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/terms"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/biometric"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/biometric"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/faqs"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/faqs"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/cookies"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/cookies"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/wf-events"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/events"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Redirect
                exact
                from="/:country(us|uk)?/research"
                to="/:country(us|uk)?/news/workforce-com-builds-on-nearly-100-years-of-hr-research"
              />
              <Route
                exact
                path="/:country(us|uk)?/research"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/research"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/videos"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/videos"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/videos/watch/:slug"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/player"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/awards"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/awards"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/gdpr"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/gdpr"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Route
                exact
                path="/:country(us|uk)?/search/:pageNo?"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/search"),
                    loading: LoadingProgress,
                  })
                )}
              />

              {/* Redirect software page to new homepage */}

              <Redirect exact from="/software" to="/:country(us|uk)?/" />
              <Redirect
                exact
                from="/commentary/feed/"
                to="/:country(us|uk)?/news"
              />
              {/* Short URL request from Tas */}
              <Redirect
                exact
                from="/retail"
                to="/:country(us|uk)?/news/retail-workforce-management-success-goes-beyond-productive-operations"
              />
              {/* Short URL request from Hiren */}
              <Redirect exact from="/care" to="/uk/industry/aged-care" />
              <Redirect exact from="/event/:var?" to="/:country(us|uk)?/news" />
              <Redirect
                exact
                from="/articles/20131-companies-recognizing-importance-of-recognition-rewards-recognition-providers"
                to="/:country(us|uk)?/news/companies-recognizing-importance-of-recognition-rewards-recognition-providers"
              />
              <Redirect
                exact
                from="/articles/20179-what-is-the-future-of-hr"
                to="/:country(us|uk)?/news/what-is-the-future-of-hr"
              />
              <Redirect
                exact
                from="/articles/20439-baby-boon"
                to="/:country(us|uk)?/news/family-act-a-baby-boon"
              />
              <Redirect
                exact
                from="/:country(us|uk)?/wf-events/:var?"
                to="/:country(us|uk)?/wf-events"
              />
              <Redirect
                exact
                from="/events/:var?"
                to="/:country(us|uk)?/wf-events"
              />
              <Redirect
                exact
                from="/events/category/webinars/"
                to="/:country(us|uk)?/wf-events"
              />
              <Redirect
                exact
                from="/wf-events/hr-trends-2020-the-next-decade-of-work"
                to="/:country(us|uk)?/wf-events"
              />
              <Redirect exact from="/page/:var?" to="/:country(us|uk)?/news" />
              <Redirect exact from="/newsletter" to="/:country(us|uk)?/news" />
              <Redirect
                exact
                from="/uk/privacy-policy"
                to="/eu/privacy-policy"
              />
              <Redirect
                exact
                from="/:country(us|uk)?/app-marketplace"
                to="/:country(us|uk)?/integrations"
              />
              <Redirect
                exact
                from="/payroll"
                to="/:country(us|uk)?/integrations"
              />
              <Redirect
                exact
                from="/images/files/integration.pdf"
                to="/:country(us|uk)?/integrations"
              />
              <Redirect exact from="/login" to="/:country(us|uk)?/" />
              <Redirect exact from="/signin" to="/:country(us|uk)?/" />
              <Redirect exact from="/register" to="/:country(us|uk)?/" />
              <Redirect
                exact
                from="/terms-of-use/awards/"
                to="/:country(us|uk)?/news/terms-of-use"
              />
              <Redirect exact from="/proxy.php" to="/:country(us|uk)?/news" />
              <Redirect
                exact
                from="/waghorne-kristen-profile-wf/"
                to="/:country(us|uk)?/news"
              />
              <Redirect exact from="/roadmaps" to="/:country(us|uk)?/" />
              <Redirect exact from="/intuit" to="/:country(us|uk)?/news" />
              <Redirect exact from="/intuit.com" to="/:country(us|uk)?/news" />
              <Redirect exact from="/feed" to="/:country(us|uk)?/news" />
              <Redirect
                exact
                from="/Game-changers"
                to="/:country(us|uk)?/news"
              />
              <Redirect exact from="/hot-jobs/" to="/:country(us|uk)?/news" />
              <Redirect
                exact
                from="/hs/manage-preferences/:var"
                to="/:country(us|uk)?/news"
              />
              <Redirect
                exact
                from="/florine-van-everdingen/"
                to="/:country(us|uk)?/news"
              />
              <Redirect exact from="/jobs" to="/:country(us|uk)?/news" />
              <Redirect exact from="/e2t/c/" to="/:country(us|uk)?/news" />
              <Redirect exact from="/1970s" to="/:country(us|uk)?/news" />
              <Redirect exact from="/adp" to="/:country(us|uk)?/news" />

              <Redirect
                exact
                from="/article-author/dr-sullivan/"
                to="/:country(us|uk)?/news"
              />
              <Redirect
                exact
                from="/awards/optimas/"
                to="/:country(us|uk)?/news/optimas-awards"
              />
              <Redirect exact from="/awards/:var" to="/:country(us|uk)?/news" />
              <Redirect exact from="/bios/:var" to="/:country(us|uk)?/news" />
              <Redirect exact from="/calsonic" to="/:country(us|uk)?/news" />
              <Redirect exact from="/capri" to="/:country(us|uk)?/news" />
              <Redirect
                exact
                from="/workforce-100"
                to="/:country(us|uk)?/news"
              />
              <Redirect
                exact
                from="/workforce100-winners/:var"
                to="/:country(us|uk)?/news"
              />
              <Redirect exact from="/rss/:var" to="/:country(us|uk)?/news" />
              <Redirect
                exact
                from="/section/:var?/:var?/:var?/:var?/:var?"
                to="/:country(us|uk)?/news"
              />
              <Redirect
                exact
                from="/article/:var/:var/:var/:slug"
                to="/:country(us|uk)?/news/:slug"
              />
              <Redirect
                exact
                from="/articles/21548-the-work-life-harried-go-round"
                to="/:country(us|uk)?/news/the-work-life-harried-go-round"
              />
              <Redirect
                exact
                from="/articles/21557-more-power-to-you-taking-charge-of-powerless-feelings"
                to="/:country(us|uk)?/news/more-power-to-you-taking-charge-of-powerless-feelings"
              />
              <Redirect
                exact
                from="/articles/21937-thomas-derosa-interview-envisioning-the-workforce-in-2100"
                to="/:country(us|uk)?/news/thomas-derosa-interview-envisioning-the-workforce-in-2100"
              />
              <Redirect
                exact
                from="/articles/21959-prep-for-fads-from-holacracy-to-continuous-feedback"
                to="/:country(us|uk)?/news/prep-for-fads-from-holacracy-to-continuous-feedback"
              />
              <Redirect
                exact
                from="/articles/22033-workforce-100-a-best-workplace-takes-hard-work"
                to="/:country(us|uk)?/news/workforce-100-a-best-workplace-takes-hard-work"
              />
              {/* Redirects from Mike */}
              <Redirect
                exact
                from="/:country(us|uk)?/news/what-is-workforce-management-different-departments-different-ideas"
                to="/:country(us|uk)?/workforce-management"
              />
              <Redirect
                exact
                from="/:country(us|uk)?/news/10-keys-to-a-sensible-overtime-policy"
                to="/:country(us|uk)?/news/reduce-overtime"
              />
              <Redirect
                exact
                from="/:country(us|uk)?/news/how-to-schedule-employees-effectively-5-proven-steps"
                to="/:country(us|uk)?/news/how-to-schedule-employees"
              />
              <Redirect
                exact
                from="/:country(us|uk)?/news/what-employers-and-hr-should-expect-from-new-labor-secretary-marty-walsh"
                to="/:country(us|uk)?/news/labor-secretary-marty-walsh"
              />
              <Redirect
                exact
                from="/articles/print/:slug"
                to="/:country(us|uk)?/news/:slug"
              />
              <Redirect
                exact
                from="/articles/:slug"
                to="/:country(us|uk)?/news/:slug"
              />
              <Redirect
                exact
                from="/:year/:month/:day/:slug/:extension?"
                to="/:country(us|uk)?/news/:slug"
              />

              <Route
                exact
                strict
                sensitive
                path="/:country(us|uk)?/news/:slug"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/singlePost"),
                    loading: LoadingProgress,
                  })
                )}
              />
              <Redirect
                from="/NEWS/WHO-PAYS-FOR-EMPLOYER-MANDATED-COVID-19-TESTS"
                to="/:country(us|uk)?/news/who-pays-for-employer-mandated-covid-19-tests"
              />
              <Redirect from="/NEWS" to="/:country(us|uk)?/news" />
              <Redirect
                from="/topics/:slug?"
                to="/:country(us|uk)?/category/:slug?/:pageNo?"
              />
              <Redirect
                from="/topics/:slug?/page/:pageNo?"
                to="/:country(us|uk)?/category/:slug/:pageNo?"
              />
              <Route
                exact
                path="/:country(us|uk)?/category/:slug/:pageNo?"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/category"),
                    loading: LoadingProgress,
                  })
                )}
              />

              <Redirect
                from="/article-author/:slug?"
                to="/:country(us|uk)?/author/:slug?/:pageNo?"
              />
              <Redirect
                from="/article-author/:slug?/page/:pageNo?"
                to="/:country(us|uk)?/author/:slug/:pageNo?"
              />

              <Route
                exact
                path="/:country(us|uk)?/author/:slug/:pageNo?"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/author"),
                    loading: LoadingProgress,
                  })
                )}
              />

              <Redirect
                from="/tag/:slug?/page/:pageNo?"
                to="/:country(us|uk)?/tag/:slug/:pageNo?"
              />

              <Route
                exact
                path="/:country(us|uk)?/tag/:slug/:pageNo?"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/tag"),
                    loading: LoadingProgress,
                  })
                )}
              />

              <Route
                exact
                path="/404"
                component={withTracker(
                  Loadable({
                    loader: () => import("./pages/404"),
                    loading: LoadingProgress,
                  })
                )}
              />
              {/* SEO Redirects START */}
              <Redirect exact from="/join" to="/try" />
              <Redirect exact from="/index.html" to="/" />
              <Redirect
                exact
                from="/optimas"
                to="/news/introducing-2019s-workforce-optimas-awards-winners"
              />
              <Redirect exact from="/subscribe" to="/" />
              {/* SEO Redirects END */}
              <Redirect path="*" to="/404" />
            </Switch>
          </Layout>
        </BrowserRouter>
      </React.Fragment>
    );
  }
}
export default App;
